import React from 'react'
import { useHistory } from 'react-router-dom'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconEdit } from '../../../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useRoleSysApp } from '../../../../../../role/hook/role-sys'
import { useApiFormApp } from '../../../../../../api-new/state/config'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { FormSimpleSubmitCreate } from '../../../../../../shared/form-simple/form-submit'

export const AppAdd = () => {
  const history = useHistory()

  const apiFormApp = useApiFormApp()

  const roleSysApp = useRoleSysApp()

  const handleSubmit = async data => {
    let app = await apiFormApp.post(data)
    if (roleSysApp.accessUpdate) history.push(`/admin/app/edit/${app.id}`)
    else history.push(`/admin/app`)
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconEdit} text="Add app">
        <CardFullHeightScrollY title="add app">
          <FormSimple onSubmit={handleSubmit}>
            <FormSimpleText label="app name" name="name" required autoFocus />
            <FormSimpleSubmitCreate backURL="/admin/app" />
          </FormSimple>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
